import * as tslib_1 from "tslib";
import { themr } from '@nextiva/analytics-lib';
import { SvgIcon } from '@nextiva/next-ui';
import { setDateRangeEndToNow } from "../../utils";
import cx from 'classnames';
import React, { Component } from 'react';
import DateRangeLabel from '../DateRangeLabel';
import XbertTooltip from '../XbertTooltip';
import calendarIcon from './assets/calendar.svg';
import refreshIcon from './assets/refresh.svg';
import presets from './constants/presets';
import Styles from "./DateRangePicker.css";
import DrpPopover from './DrpPopover/DrpPopover';

var DateRangePicker =
/** @class */
function (_super) {
  tslib_1.__extends(DateRangePicker, _super);

  function DateRangePicker() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isRealTime: _this.props.isRealTime || false
    };

    _this.changeEndToNow = function () {
      var _a = _this.props,
          dateRange = _a.dateRange,
          onChange = _a.onChange;
      onChange(setDateRangeEndToNow(dateRange));
    };

    _this.handleChange = function (dateRange) {
      var _a = _this.props,
          isRealTime = _a.isRealTime,
          onChange = _a.onChange;

      if (isRealTime) {
        dateRange = setDateRangeEndToNow(dateRange);
      }

      onChange(dateRange);
    };

    _this.handleToggleRealTime = function () {
      _this.setState(function (state) {
        var isRealTime = !state.isRealTime;

        _this.changeEndToNow();

        _this.props.onRealTimeChange(isRealTime);

        return {
          isRealTime: isRealTime
        };
      });
    };

    return _this;
  }

  DateRangePicker.getDerivedStateFromProps = function (props, prevState) {
    if (prevState && prevState.isRealTime !== props.isRealTime) {
      return {
        isRealTime: props.isRealTime
      };
    }

    return null;
  };

  DateRangePicker.prototype.componentDidMount = function () {
    if (this.props.isRealTime) {
      this.changeEndToNow();
    }
  };

  DateRangePicker.prototype.render = function () {
    var _a;

    var _b = this.props,
        className = _b.className,
        dateRange = _b.dateRange,
        timezone = _b.timezone,
        theme = _b.theme,
        startDateFormat = _b.startDateFormat,
        endDateFormat = _b.endDateFormat,
        withRealTimeIcon = _b.withRealTimeIcon,
        isPeriod = _b.isPeriod,
        onChangeCancel = _b.onChangeCancel,
        relativeUnits = _b.relativeUnits,
        isDarkTheme = _b.isDarkTheme,
        disabled = _b.disabled,
        isOpen = _b.isOpen,
        realTimeTooltipMessage = _b.realTimeTooltipMessage;
    var isRealTime = this.state.isRealTime;
    return React.createElement("div", {
      className: theme.dateRangePicker
    }, React.createElement(DrpPopover, {
      className: className,
      presets: this.props.presets,
      dateRange: dateRange,
      timezone: timezone,
      isPeriod: isPeriod,
      isRealTime: isRealTime,
      relativeUnits: relativeUnits,
      onChange: this.handleChange,
      onChangeCancel: onChangeCancel,
      disabled: disabled,
      isOpen: isOpen
    }, React.createElement(SvgIcon, {
      className: theme.calendarIcon,
      src: calendarIcon
    }), React.createElement(DateRangeLabel, {
      dataTest: "date-range-picker-label",
      dateRange: dateRange,
      timezone: timezone,
      startDateFormat: startDateFormat,
      endDateFormat: endDateFormat,
      isRealTime: isRealTime,
      isDarkTheme: isDarkTheme
    })), withRealTimeIcon && React.createElement(XbertTooltip, {
      tipContent: realTimeTooltipMessage,
      tipId: "date-range-tip",
      theme: {
        xbertTooltip: theme.overrideXbertTooltip
      },
      tipItem: React.createElement(SvgIcon, {
        className: cx(theme.realTime, (_a = {}, _a[theme.realTimeActive] = isRealTime, _a)),
        src: refreshIcon,
        onClick: this.handleToggleRealTime
      })
    }));
  };

  DateRangePicker.defaultProps = {
    dateRange: tslib_1.__assign({
      type: 'relative'
    }, presets.Today),
    timezone: '',
    isRealTime: false,
    isOpen: false,
    onChange: function onChange() {},
    onChangeCancel: function onChangeCancel(error) {
      return alert(error.message);
    },
    onRealTimeChange: function onRealTimeChange() {},
    isDarkTheme: false,
    realTimeTooltipMessage: 'Click icon for real-time'
  };
  return DateRangePicker;
}(Component);

var DateRangePickerWithTheme = themr(DateRangePicker, Styles);
export default DateRangePickerWithTheme;